// extracted by mini-css-extract-plugin
export default {"current-user-avatar":"current-user-avatar_current-user-avatar__988XY"};